<div class="content">
  <p class="title is-capitalized">Out of Stocks</p>
  <p class="subtitle">Sorry! We don't currently have a substitution for these items.</p>
</div>
<app-product-list [list]="list" qtyField="SCR_QTY" display="oos"></app-product-list>
